import { transform } from "./transform";

describe("transform", () => {
    it("the value is returned as is if the format function is undefined", () => {
        const formatFn = undefined;

        const formattedValue = transform(formatFn, 100);
        expect(formattedValue).toBe(100);
    });

    it("the value is returned as is if the format function is null", () => {
        const formatFn = null;

        const formattedValue = transform(formatFn, 100);
        expect(formattedValue).toBe(100);
    });

    it("the value is formatted according to the function", () => {
        const formatFn = (x: number) => Math.round(x);

        const formattedValue = transform(formatFn, 100.5);
        expect(formattedValue).toBe(101);
    });
});
